import digimon from '../img-angular/digimons.png';
import pokedex from '../img-angular/pokedex.png';
import quizz from '../img-angular/quizz.png';
import x_man from '../img-angular/x-man.png';
import pokedex_ from '../img-angular/pokedex_.png';


const data = [
  {
    id: 1,
    title: 'Digimons',
    image: digimon,
    link: 'https://master--euphonious-chaja-55b1e0.netlify.app/'
  },  
  {
    id: 2,
    title: 'Pokedex',
    image: pokedex,
    link: 'https://master--subtle-belekoy-eacccf.netlify.app/'
  },
  {
    id: 3,
    title: 'Quizz',
    image: quizz,
    link: 'https://master--scintillating-swan-277c5c.netlify.app/'
  },
  {
    id: 4,
    title: 'Blog',
    image: x_man,
    link: 'https://master--lively-puppy-aafe9d.netlify.app/'
  },
  {
    id: 5,
    title: 'Pokedex_',
    image: pokedex_,
    link: 'https://master--subtle-belekoy-eacccf.netlify.app/'
  },
]

export default data;